// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  productUrl: 'https://admin-pciprint.ddns.net/', // <Your store base url>
  productUrl2: 'https://admin-pciprint.ddns.net/', // <Your store base url>
  baseUrl: "https://api-pciprint.ddns.net/api",
  imageUrl: 'https://api-pciprint.ddns.net/api/media/image-resize' // <Your API url for image resize>
};

/* export const environment = {
  production: false,
  productUrl: 'http://localhost:4200/', // <Your store base url>
  productUrl2: 'http://localhost:4200/', // <Your store base url>
  baseUrl: "http://127.0.0.1:9000/api", 
  imageUrl: 'http://127.0.0.1:9000/api/media/image-resize' // <Your API url for image resize>
};  */

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

/*


id
last_name
last_name
username
email
password
mobile
address
country_id
city
pincode
avatar
avatar_path
mail_status
delete_flag
customer_group_id
last_login
newsletter
safe
ip
zone_id
local
oauth_data
is_active
created_by
modified_by
created_date
modified_date
grupo_id
rfc
razon_social
nacimiento
telefono
telefono2
agente_cuenta_id
agente_comision
horario
tipo_cliente
plazo_credito
encargado_pagos
tel_encargado
encargado_email
revision_dias
revision_forma_pago
ultimos_digitos
bancos
uso_cfdi
horario_revision

alter table customer add column  text;
alter table customer add column apellido_materno  text; 
alter table customer add column curp  text; 
alter table customer add column razon_comercial  text; 
alter table customer add column cp  text; 
alter table customer add column asentamiento  text; 
alter table customer add column municipio  text; 
alter table customer add column estado  text; 
alter table customer add column intervalo revision  text; 

*/

/*
{
  "productName": "Volantes Generales (Prueba)",
  "productDescription": "<p>Descripcion general</p>\n",

  "condition": 1,
  "productDiscount": [],
  "campos": [
    {
      "product_field_id": 247,
      "product_id": 657,
      "nombre": "tamano",
      "tipo": "Único",
      "valor": "",
      "opciones": [
        {
          "texto": "1/4 de carta",
          "valor_selecionado": "1/4 de carta",
          "tipo": "",
          "valor_agregado": "0",
          "default": "",
          "titulo": "1/4 de carta",
          "descripcion": "tu mejor opción economica. sdlkfjskldjflksjalñkfj\nsdfkljsdfkl\nsfjlsdkfjsdklf",
          "largo": "10",
          "alto": "20",
          "imagen_url": "",
          "cambia_precios": "",
          "tooltip": {
            "titulo": "1/4 de carta",
            "descripcion": "tu mejor opción economica. sdlkfjskldjflksjalñkfj\nsdfkljsdfkl\nsfjlsdkfjsdklf"
          }
        },
        {
          "texto": "1/2 de carta",
          "valor_selecionado": "1/2 de carta",
          "tipo": "",
          "valor_agregado": "50",
          "default": "",
          "titulo": "",
          "descripcion": "",
          "largo": "15",
          "alto": "20",
          "imagen_url": "",
          "cambia_precios": ""
        },
        {
          "texto": "Carta",
          "valor_selecionado": "carta",
          "tipo": "",
          "valor_agregado": "+50%",
          "default": "",
          "titulo": "",
          "descripcion": "",
          "largo": "20",
          "alto": "50",
          "imagen_url": "",
          "cambia_precios": ""
        }
      ],
      "titulo": "Tamaño",
      "label": "Tamaño",
      "css": "",
      "class": "col-12",
      "grid": "",
      "orden": 0,
      "visualizacion": ""
    },
    {
      "product_field_id": 248,
      "product_id": 657,
      "nombre": "acabados",
      "tipo": "Múltiple",
      "valor": "",
      "opciones": [
        {
          "texto": "Folio",
          "valor_selecionado": "folio",
          "tipo": "",
          "valor_agregado": "100",
          "default": "",
          "titulo": "",
          "descripcion": "",
          "largo": "",
          "alto": "",
          "imagen_url": "",
          "cambia_precios": ""
        },
        {
          "texto": "Taladrado",
          "valor_selecionado": "taladrado",
          "tipo": "",
          "valor_agregado": "200",
          "default": "",
          "titulo": "",
          "descripcion": "",
          "largo": "",
          "alto": "",
          "imagen_url": "",
          "cambia_precios": ""
        }
      ],
      "titulo": "Acabados",
      "label": "Acabados",
      "css": "",
      "class": "col-12",
      "grid": "",
      "orden": 1,
      "visualizacion": ""
    },
    {
      "product_field_id": 249,
      "product_id": 657,
      "nombre": "",
      "tipo": "DescuentoXVolumen",
      "valor": "",
      "opciones": [],
      "titulo": "",
      "label": "",
      "css": "",
      "class": "col-12",
      "grid": "",
      "orden": 2,
      "visualizacion": "",
      "eliminado": 1
    },
    {
      "product_field_id": "",
      "nombre": "observaciones",
      "tipo": "Texto",
      "valor": "",
      "titulo": "observaciones",
      "grid": "",
      "orden": "",
      "product_id": "",
      "css": "",
      "class": "col-12",
      "label": "observaciones",
      "validaciones": "",
      "visualizacion": "",
      "visualizacionAux": "",
      "opciones": [
        {
          "texto": "",
          "valor_selecionado": "",
          "tipo": "",
          "valor_agregado": "",
          "default": "",
          "titulo": "",
          "descripcion": "",
          "largo": "",
          "alto": "",
          "imagen_url": "",
          "cambia_precios": ""
        }
      ]
    }
  ],
  "unidad_medida": "cm",
  "cancelar_cantidad": "0",
  "medida_largo": "10",
}

*/